"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_RETRY_LIMIT = void 0;
/**
 * Customer-facing cap on online-payment attempts per order. Enforced on the
 * backend in `initiatePayment` (throws `PAYMENT_RETRY_LIMIT` 400) and gated
 * on the frontend so the Retry/Complete button swaps to Re-order at the same
 * count. Matches the reconciliation candidate cap (`take: 3` in
 * `reconcilePayment`) so the two limits stay coherent.
 */
exports.PAYMENT_RETRY_LIMIT = 3;
